import React from 'react';
import { Group, Rect } from 'react-konva';
import PetButton from './PetButton';
import { useStyle } from '../../contexts/StyleContext'; 
import { useNotification } from '../../contexts/NotificationContext'; 
import { useTranslation } from 'react-i18next'; // Importing translation hook

const Rectangle = ({
  shapeId, shapeType, x, y, sideWidth, sideHeight, color, buttons, rotation,
  draggable, onClick, selected, selectedButton, onButtonClick,
  onMouseEnter, onMouseLeave, onDragStart, onDragMove, onDragEnd,
  isDraggingShape, handleMouseEnterButton, handleMouseLeaveButton, hovered, hoveredItem, buttonLayout
}) => {

  const { petButtonRadius } = useStyle() || {};
  const { showNotification } = useNotification();
  const { t } = useTranslation(); // Hook to access translation

  const buttonPositions = buttonLayout === "two-buttons"
    ? calculateButtonPositionsForTwoButtons(0, 0, sideWidth, sideHeight)
    : [{ x: sideWidth / 2, y: sideHeight / 2 }]; // Center position for single button

  function calculateButtonPositionsForTwoButtons(centerX, centerY, sideWidth, sideHeight) {
    if (typeof centerX !== 'number' || typeof centerY !== 'number' || typeof sideWidth !== 'number' || typeof sideHeight !== 'number') {
 
      const extra = { centerX, centerY, sideWidth, sideHeight };  
      showNotification({
        notification: t('errors.snackbar.InvalidPositionorSizeRectangle'),
        type: 'error',
        extra, 
        isException: false,
      });

      return [
        { x: 0, y: 0 },
        { x: 0, y: 0 }
      ];
    }

    const positions = [
      { x: sideWidth / 2, y: centerY - (sideHeight / 4) }, // Top center
      { x: sideWidth / 2, y: centerY + (sideHeight / 4) }, // Bottom center
    ];

    return positions;
  }

  const handleSelect = (shapeId, e) => {
    e.cancelBubble = true;
    setTimeout(() => { // Ensures that the function runs after drag detection has completed.
      if (!isDraggingShape) {
          onClick(shapeId, e);
      }
    }, 0);
  };

  const handleButtonClick = (buttonId, shapeId, e) => {
    e.cancelBubble = true;
    onButtonClick(buttonId, shapeId, e);
  };

  return (
    <React.Fragment>
      <Group
        draggable={draggable}
        onDragStart={onDragStart}
        onDragMove={(e) => onDragMove(shapeId, e)} // Use the handleDragMove from Soundboard.js
        onDragEnd={(e) => onDragEnd(shapeId, e)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        rotation={rotation}
        x={x}
        y={y}
        offsetX={(hovered || selected ? sideWidth - 1 : sideWidth) / 2} // Centering the rotation point horizontally
        offsetY={(hovered || selected ? sideHeight - 1 : sideHeight) / 2} // Centering the rotation point vertically
      >
        <Rect
          width={hovered || selected ? sideWidth - 1 : sideWidth}
          height={hovered || selected ? sideHeight - 1 : sideHeight}
          fill={color}
          onClick={(e) => handleSelect(shapeId, e)}
          onPointerUp={(e) => handleSelect(shapeId, e)} // Works for both touch and mouse
          stroke={hovered && (hoveredItem.type === 'panel') ? '#dc03d1' : (selected ? '#e89b00' : '#dedede')}
          strokeWidth={hovered && (hoveredItem.type === 'panel') ? 3 : (selected ? 3 : 1 )}
          /*stroke={hovered && (hoveredItem.type === 'panel') ? '#dc03d1' : (selected ? '#e89b00' : 'transparent')}
          strokeWidth={2}*/
          strokeScaleEnabled={false}
          shadowColor={selected ? 'orange' : 'none'}
          shadowBlur={selected ? 20 : 0}
          shadowOffset={{ x: 0, y: 0 }}
          shadowOpacity={selected ? 0.9 : 0}
        />

        {buttons.map((button, index) => (
          <PetButton
            key={button._id}
            id={button._id}
            buttonId={button._id}
            buttonLabel={button.buttonLabel}
            shapeId={shapeId}
            x={buttonPositions[index].x}
            y={buttonPositions[index].y}
            radius={parseFloat(petButtonRadius)}
            color={button.color}
            rotation={rotation}
            selected={selectedButton === button._id}
            onClick={(e) => handleButtonClick(button._id, shapeId, e)}
            onPointerUp={(e) => handleButtonClick(button._id, shapeId, e)} // Works for both touch and mouse
            onMouseEnter={(buttonId, e) => handleMouseEnterButton(buttonId, e)}
            onMouseLeave={handleMouseLeaveButton}
            hovered={hoveredItem.type === 'button' && hoveredItem.id === button._id}
          />
        ))}
      </Group>
    </React.Fragment>
  );
};

export default Rectangle;
